import React from 'react';
import { map } from 'lodash';
import members from '../../data/team.json';
import { Michael, Tony, Joseph, Yiing, Ibrahim, Ibrahim_Alt, Yiing_Alt } from 'docs/teamMD';

export interface MemberInfo {
    id: string;
    name: string;
    image?: string;
    bio?: string;
    alt_lng?: string;
    alt_cls?: string;
}

export const getMembers = () => {
    const memberInfo = members as MemberInfo[];
    return memberInfo;
};

export const getDetails = (id: string) => {
    switch (id) {
        case 'michael':
            return Michael;
            break;
        case 'tony':
            return Tony;
            break;
        case 'joseph':
            return Joseph;
            break;
        case 'yiing':
            return Yiing;
            break;
        case 'yiing_alt':
            return Yiing_Alt;
            break;
        case 'ibrahim':
            return Ibrahim;
            break;
        case 'ibrahim_alt':
            return Ibrahim_Alt;
            break;
        default:
            break;
    }
    return '';
};

const MemberDetails = (info: MemberInfo) => {
    const { id, name, image, bio } = info;

    return (
        <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="member">
                <div className="member-img">{image && <img src={image} className="img-fluid" alt="" />}</div>
                <div className="member-info">
                    <h4>{name}</h4>
                    {bio && <span>{bio}</span>}
                </div>
                <div>
                    <a href={`/team/${id}`} className="btn-header animated fadeInUp scrollto">
                        More info
                    </a>
                </div>
            </div>
        </div>
    );
};

export const Team = () => {
    const members = getMembers();
    const elements = map(members, m => {
        return <MemberDetails {...m} />;
    });
    return (
        <section id="team" className="team">
            <div className="container">
                <div className="section-title">
                    <h2>Team</h2>
                    <p>Our Experienced Team</p>
                </div>
                <div className="row">{elements}</div>
            </div>
        </section>
    );
};
